<link rel="stylesheet" href="build-to-order.component.scss" />
<h1 class="stock-title">Build To Order</h1>

<app-breadcrumb></app-breadcrumb>

<br />
<div class="mt-3"></div>
<br />

<div class="container-fluid align_filters">
  <div class="row mb-3">
    <div class="col-md-3">
      <ds-form-field>
        <label ds-label for="carBrand1" class="form-label">
          Brand<span style="color: red">*</span></label
        >
        <ds-select
          id="carBrand1"
          [labellingConfig]="{ placeholder: 'Select a brand...' }"
          [options]="brandOptions"
          [(ngModel)]="filters.brand"
          (optionSelected)="onBrandChange($event)"
          required
          [showClearAll]="true"
        ></ds-select>
      </ds-form-field>
    </div>
    <div class="col-md-3">
      <ds-form-field>
        <label ds-label for="carVersion1" class="form-label">Version</label>
        <ds-select
          id="carVersion1"
          [labellingConfig]="{ placeholder: 'Select a version...' }"
          [options]="filteredVersionOptions"
          [(ngModel)]="filters.version"
          (optionSelected)="onVersionChange($event)"
          [showClearAll]="true"
        ></ds-select>
      </ds-form-field>
    </div>

    <div class="col-md-3">
      <ds-form-field>
        <label ds-label for="carModel1" class="form-label">Model</label>
        <ds-select
          id="carModel1"
          [labellingConfig]="{ placeholder: 'Select a model...' }"
          [options]="filteredModelOptions"
          [(ngModel)]="filters.model"
          (optionSelected)="onModelChange($event)"
          [showClearAll]="true"
        ></ds-select>
      </ds-form-field>
    </div>
    <div class="col-md-3">
      <div class="search-button-container align_btn">
        <button
          ds-button
          ds-loading
          class="btn btn-primary"
          icon="search"
          [disabled]="!isBrandSelected"
          (click)="searchBto()"
        >
          Search Build to order
        </button>
      </div>
    </div>
  </div>
  <br />
</div>
<br />
<div class="content_bg styled-section" *ngIf="seachClicked">
  <table class="scrollable-table">
    <ds-tabs class="content_bg_color" *ngIf="seachClicked">
      <ds-tabs-label
        for="open"
        (click)="onRTPTabClicked(); $event.preventDefault()"
      >
        RTP
      </ds-tabs-label>
      <ds-tabs-content id="open">
        <div class="tab-content">
          <ng-container *ngIf="seachClicked; else notYetSearched">
            <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
              <div class="table-section">
                <div class="table-scroll-container">
                  <table
                    *ngIf="rowsData.length > 0"
                    class="ds-table zebra-table fixed-header-table"
                  >
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Model Code</th>
                        <th>Description</th>
                        <th>Quote ID</th>
                        <th>Quote Version</th>
                        <th>Quote Date</th>
                        <th>Customer</th>
                        <!--                <th></th>-->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of rowsData">
                        <td>
                            @if (row['image'] === '') {
                                <ds-progress-circle
                                        size="sm"
                                        class="image-loader"
                                ></ds-progress-circle>
                            } @else {
                          <div class="image-popup-wrapper">

                            <img
                              [src]="row['image'] || 'image placeholder'"
                              alt="Image"
                              width="80"
                            />
                            <div class="image-hover-popup">
                              <img
                                [src]="row['image']"
                                alt="Vehicle Enlarged View"
                              />
                            </div>
                          </div>
                            }
                        </td>
                        <td>{{ row['modelCode'] }}</td>
                        <td>{{ row['description'] }}</td>
                        <td>{{ row['quoteId'] }}</td>
                        <td>{{ row['quoteVersion'] }}</td>
                        <td>{{ row['quoteDate'] }}</td>
                        <td>{{ row['customer'] }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ds-tabs-content>

      <ds-tabs-label
        for="cancelled"
        (click)="onRTPSignedTabClicked(); $event.preventDefault()"
      >
        RTP Signed
      </ds-tabs-label>
      <ds-tabs-content id="cancelled">
        <div class="tab-content">
          <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
            <div class="table-section">
              <div class="table-scroll-container">
                <table
                  *ngIf="rowsData.length > 0"
                  class="ds-table zebra-table fixed-header-table no-image-table"
                >
                  <thead>
                    <tr>
                      <th>Model Code</th>
                      <th>Description</th>
                      <th>Quote ID</th>
                      <th>Quote Version</th>
                      <th>Quote Date</th>
                      <th>Customer</th>
                      <th>POP Received</th>
                      <th>RTP Received</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of rowsData">
                      <td>{{ row['modelCode'] }}</td>
                      <td>{{ row['description'] }}</td>
                      <td>{{ row['quoteId'] }}</td>
                      <td>{{ row['quoteVersion'] }}</td>
                      <td>{{ row['quoteDate'] }}</td>
                      <td>{{ row['customer'] }}</td>
                      <td>
                        <span
                          [ngClass]="{
                            'dsp-yes':
                              row['popReceived'].toString().toLowerCase() ===
                              'yes',
                            'dsp-no':
                              row['popReceived'].toString().toLowerCase() ===
                              'no',
                          }"
                          class="dsp-badge"
                        >
                          {{ row['popReceived'] }}
                        </span>
                      </td>
                      <td>
                        <span
                          [ngClass]="{
                            'dsp-yes':
                              row['rtpReceived'].toString().toLowerCase() ===
                              'yes',
                            'dsp-no':
                              row['rtpReceived'].toString().toLowerCase() ===
                              'no',
                          }"
                          class="dsp-badge"
                        >
                          {{ row['rtpReceived'] }}
                        </span>
                      </td>
                      <td style="align-items: center; gap: 10px">
                        <!--                <ds-icon-->
                        <!--                  icon="eye"-->
                        <!--                  size="md"-->
                        <!--                  title="Unit Summary"-->
                        <!--                  style="cursor: pointer; color: #037493"-->
                        <!--                  class="update millage"-->
                        <!--                ></ds-icon>-->

                        <ds-icon
                          icon="upload"
                          size="md"
                          title="Upload Documents"
                          (click)="
                            openRTPUploadDownloadModal(
                              row['quoteId'],
                              row['modelCode'],
                              row['description'],
                              row['customer'],
                              'upload',
                              row['popReceived'],
                              row['rtpReceived']
                            )
                          "
                          style="cursor: pointer; color: #037493"
                          class="action transfer"
                        ></ds-icon>
                        <ds-icon
                          icon="download"
                          size="md"
                          title="Download Documents"
                          (click)="
                            openRTPUploadDownloadModal(
                              row['quoteId'],
                              row['modelCode'],
                              row['description'],
                              row['customer'],
                              'download',
                              row['popReceived'],
                              row['rtpReceived']
                            )
                          "
                          style="cursor: pointer; color: #037493"
                          class="action transfer"
                        ></ds-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>
      </ds-tabs-content>
      <ds-tabs-label
        for="linked"
        (click)="onOTPLinkedTabClicked(); $event.preventDefault()"
      >
        OTP Linked
      </ds-tabs-label>
      <ds-tabs-content id="linked">
        <div class="tab-content">
          <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
            <div class="table-section">
              <div class="table-scroll-container">
                <table *ngIf="rowsData.length > 0" class="ds-table zebra-table">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>BodyNo</th>
                      <th>Model Code</th>
                      <th>Description</th>
                      <th>Quote ID</th>
                      <th>Quote Version</th>
                      <th>Quote Date</th>
                      <th>Customer</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of rowsData">
                      <td>
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row['image'] || 'image placeholder'"
                            alt="Image"
                            width="80"
                          />
                          <div class="image-hover-popup">
                            <img
                              [src]="row['image']"
                              alt="Vehicle Enlarged View"
                            />
                          </div>
                        </div>
                      </td>

                      <td>
                        <a
                          [href]=" row['bodyNo'] | unitOverviewLink"
                          target="_blank"
                          rel="noopener"
                          style="
                            font-weight: bold;
                            color: #037493;
                            text-decoration: none;
                            cursor: pointer;
                          "
                          title="View Unit Overview"
                        >
                          {{ row['bodyNo'] }}
                        </a>
                      </td>
                      <td>{{ row['modelCode'] }}</td>
                      <td>{{ row['description'] }}</td>
                      <td>{{ row['quoteId'] }}</td>
                      <td>{{ row['quoteVersion'] }}</td>
                      <td>{{ row['quoteDate'] }}</td>
                      <td>{{ row['customer'] }}</td>
                      <td>
                        <!--                <ds-icon-->
                        <!--                  icon="eye"-->
                        <!--                  size="md"-->
                        <!--                  title="Unit Summary"-->
                        <!--                  style="cursor: pointer; color: #037493"-->
                        <!--                  class="update millage"-->
                        <!--                ></ds-icon>-->
                        <ds-icon
                          icon="download"
                          size="md"
                          title="Download Documents"
                          (click)="
                            openRTPUploadDownloadModal(
                              row['quoteId'],
                              row['modelCode'],
                              row['description'],
                              row['customer'],
                              'download',
                              row['popReceived'],
                              row['rtpReceived']
                            )
                          "
                          style="cursor: pointer; color: #037493"
                          class="action transfer"
                        ></ds-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>
      </ds-tabs-content>
    </ds-tabs>
  </table>
</div>
<br />
<div class="mt-3"></div>
<br />
<ds-modal
  #rtpUploadDownloadModal
  [ds-modal-trigger-for]="rtpUploadDownloadModal"
  [(isModalOpen)]="rtpUploadDownloadModalIsOpen"
  [dimensionsConfig]="{ width: '526px' }"
  (dismiss)="closeRTPModal()"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <span *ngIf="rtpUploadDownloadModalData.action === 'upload'">
      Upload BTO documents
    </span>
    <span *ngIf="rtpUploadDownloadModalData.action === 'download'">
      Download BTO Documents
    </span>
  </ds-box-header>
  <ds-box-content>
    <div>
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">quote:</div>
        <div>{{ rtpUploadDownloadModalData.quoteId }}</div>
      </div>
      <br />
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">Model:</div>
        <div>
          {{ rtpUploadDownloadModalData.modelCode }} -
          {{ rtpUploadDownloadModalData.modelDescription }}
        </div>
      </div>
      <br />
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">Client:</div>
        <div>{{ rtpUploadDownloadModalData.customerName }}</div>
      </div>
      <br />
      <div style="display: flex; gap: 8px; align-items: center">
        <div style="width: 150px">Document Type:</div>
        <div>
          <ds-radio-group variant="inline">
            <input
              ds-input
              (change)="onDocTypeChange($event)"
              [disabled]="
                rtpUploadDownloadModalData.popReceived !== 'Yes' &&
                rtpUploadDownloadModalData.action === 'download'
              "
              id="otpDoc"
              type="radio"
              name="docType"
              value="POP"
              [(ngModel)]="rtpUploadDownloadModalData.docType"
            />
            <label ds-label for="otpDoc">Proof Of Payment</label>
            <input
              ds-input
              (change)="onDocTypeChange($event)"
              [disabled]="
                rtpUploadDownloadModalData.rtpReceived !== 'Yes' &&
                rtpUploadDownloadModalData.action === 'download'
              "
              id="rtpDoc"
              type="radio"
              name="docType"
              value="RTP"
              [(ngModel)]="rtpUploadDownloadModalData.docType"
            />
            <label ds-label for="rtpDoc">Signed Request To Purchase</label>
          </ds-radio-group>
        </div>
      </div>
      <br />

      <span *ngIf="rtpUploadDownloadModalData.action === 'upload'">
        <div style="display: flex; align-items: center; gap: 8px">
          <label ds-label for="rtpDocUpload" style="width: 220px">
            Document:
          </label>
          <input
            ds-input
            id="rtpDocUpload"
            type="file"
            required
            placeholder="upload document"
            (input)="onFileChange($event)"
            [(ngModel)]="popDocFile"
          />
        </div>
      </span>
      <br />
    </div>
  </ds-box-content>
  <ds-box-footer>
    <span *ngIf="rtpUploadDownloadModalData.action === 'download'">
      <button
        [disabled]="isDocumentsAvailable()"
        ds-button
        (click)="downloadRTPDocuments()"
      >
        Confirm Download
      </button>
    </span>
    <span *ngIf="rtpUploadDownloadModalData.action === 'upload'">
      <button ds-button (click)="uploadRTPDocuments()">Upload Documents</button>
    </span>
  </ds-box-footer>
</ds-modal>

<ds-modal
  #uploadConfirmationModal
  [ds-modal-trigger-for]="uploadConfirmationModal"
  [(isModalOpen)]="uploadConfirmationModalIsOpen"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    {{ uploadConfirmationModalData.title }}
  </ds-box-header>
  <ds-box-content>
    <div>
      <span>
        {{ uploadConfirmationModalData.message }}
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button ds-button (click)="close()">Close</button>
  </ds-box-footer>
</ds-modal>
<ng-template #notYetSearched>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
      <p style="margin: 0">
        Click 'RTP/RTP Signed or OTP Linked' Tab to find what you need.
      </p>
    </div>
  </div>
</ng-template>
<ng-template #noStock>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS FOUND</h1>
      <p style="margin: 0">
        Try adjusting your search criteria in the filters.
      </p>
    </div>
  </div>
</ng-template>
<app-eye-modal></app-eye-modal>
